import { useMutation } from '@tanstack/react-query';
import * as Api from '../api';

export const useStartPhoneSetup = () =>
  useMutation({
    mutationFn: async (values: { phone: string }) => {
      const { data } = await Api.StartPhoneSetup(values);
      return data;
    },
  });
